export enum settingsFieldType {
	TOGGLE = "TOGGLE",
	DROPDOWN = "DROPDOWN",
}